export enum AccountTypes {
  payoneer = 'payoneer',
  tipaltiPaypal = 'tipalti-paypal',
  tipaltiWireTransfer = 'tipalti-wire-transfer',
  tipaltiEcheck = 'tipalti-echeck',
  tipaltiNoPaymentMethod = 'tipalti-no-payment-method',
  tipaltiAch = 'tipalti-ach',
}

export enum AdvanceType {
  release = 'release',
  user = 'user',
  asset = 'asset',
}

export enum AdvanceTypeNames {
  release = 'Release',
  user = 'Account Level',
  asset = 'Track',
}

export const TipaltiAccountTypes = [
  AccountTypes.tipaltiEcheck,
  AccountTypes.tipaltiPaypal,
  AccountTypes.tipaltiWireTransfer,
  AccountTypes.tipaltiNoPaymentMethod,
  AccountTypes.tipaltiAch,
]

export enum KycStatus {
  required = 'required',
  inProgress = 'in progress',
  approved = 'approved',
  rejected = 'rejected',
}

export enum PayoneerStatusIds {
  active = 1,
  pending = 0,
  inactive = 99,
}

export enum ReleaseStatus {
  partiallyCompleted = 1,
  processing,
  sentToStores,
  requestedTakedown,
  removed,
  inactive,
  active,
  incomplete,
  approved,
  requiresRepair,
  awaitingExplicitContentCheck,
}

export enum ReleaseType {
  single = 'Single',
  ep = 'EP',
  album = 'Album',
}

export enum TransactionStatus {
  accepted = 'Accepted',
  approval = 'Approval',
  cancelled = 'Cancelled',
  failed = 'Failed',
  paid = 'Paid',
  pending = 'Pending',
  pendingPayee = 'Pending Payee',
  processing = 'Processing',
  processingError = 'Processing Error',
  rejected = 'Rejected',
  requested = 'Requested',
}

export enum TrolleyStatus {
  active = 'active',
  incomplete = 'incomplete',
  disabled = 'disabled',
  archived = 'archived',
  suspended = 'suspended',
  blocked = 'blocked',
}

export const supportedCurrencyConversions = [
  'EUR',
  'USD',
]

export enum currencySymbol {
  EUR = '€',
  GBP = '£',
  USD = '$',
}

export enum PayoutAccountStatuses {
  pending = 'pending',
  active = 'active',
  blocked = 'blocked',
}

export enum SubscriptionTypes {
  revenuecat = 'revenuecat',
  rls = 'rls',
  manual = 'manual',
  stripe = 'stripe',
}
